const FormatDate = (dateString) => {
  if (!dateString) return ""; // Handle null or undefined input safely

  const [year, month, day] = dateString.split("-");

  // Ensure month and day are always two digits
  const formattedMonth = month.padStart(2, "0");
  const formattedDay = day.padStart(2, "0");

  return `${formattedDay}/${formattedMonth}/${year}`;
};

export default FormatDate;